
interface DocumentsFiltersProps {
  filters: {
    search: string;
    type: string;
    project: string;
    municipality: string;
    status: string;
    hasBinding: string;
    hasFile: string;
    isExpired: string;
  };
  onChange: (filters: DocumentsFiltersProps["filters"]) => void;
  /** Tipos e status presentes nos documentos reais (derivados da lista carregada). */
  typeOptions: string[];
  statusOptions: string[];
}

export default function DocumentsFilters({ filters, onChange, typeOptions, statusOptions }: DocumentsFiltersProps) {
  const handleChange = (field: string, value: string) => {
    onChange({ ...filters, [field]: value });
  };

  const handleClear = () => {
    onChange({
      search: "",
      type: "",
      project: "",
      municipality: "",
      status: "",
      hasBinding: "",
      hasFile: "",
      isExpired: "",
    });
  };

  const hasActiveFilters = Object.values(filters).some((v) => v !== "");

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center gap-3">
        <div className="relative flex-1 min-w-[200px] max-w-[400px]">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
          <input
            type="text"
            value={filters.search}
            onChange={(e) => handleChange("search", e.target.value)}
            className="w-full pl-9 pr-4 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-800 focus:outline-none focus:border-primary-300"
            placeholder="Buscar por título, número, código, projeto ou responsável..."
          />
        </div>

        <select
          value={filters.type}
          onChange={(e) => handleChange("type", e.target.value)}
          className="px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-800 focus:outline-none focus:border-primary-300"
        >
          <option value="">Todos os tipos</option>
          {typeOptions.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>

        <select
          value={filters.status}
          onChange={(e) => handleChange("status", e.target.value)}
          className="px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-800 focus:outline-none focus:border-primary-300"
        >
          <option value="">Todos os status</option>
          {statusOptions.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>

        <select
          value={filters.isExpired}
          onChange={(e) => handleChange("isExpired", e.target.value)}
          className="px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-800 focus:outline-none focus:border-primary-300"
        >
          <option value="">Todas validades</option>
          <option value="yes">Vencidos</option>
          <option value="no">Dentro da validade</option>
        </select>

        <select
          value={filters.hasFile}
          onChange={(e) => handleChange("hasFile", e.target.value)}
          className="px-3 py-2 text-sm border border-background-200 rounded-lg bg-white text-foreground-800 focus:outline-none focus:border-primary-300"
        >
          <option value="">Todos arquivos</option>
          <option value="yes">Com arquivo</option>
          <option value="no">Sem arquivo</option>
        </select>

        {hasActiveFilters && (
          <button onClick={handleClear} className="px-3 py-2 text-sm font-medium text-foreground-500 hover:text-foreground-700 bg-background-50 rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap">
            <i className="ri-close-line w-4 h-4 inline-flex items-center justify-center mr-1" />
            Limpar
          </button>
        )}
      </div>
    </div>
  );
}